"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _bignumber = require("bignumber.js");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _Table = require("../../data/table/Table");
var _dateHelper = require("../../../helpers/dateHelper");
var _MarginOpenPositionsComponent = require("../MarginOpenPositions/MarginOpenPositionsComponent");
require("./PositionsHistory.css");
var _instrumentHelper = require("../../../helpers/instrumentHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('positions-history-table');
var makeCell = function makeCell(data, className) {
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    title: data + ' ' + (currency ? currency : ''),
    className: baseClass('tooltip-wrapper') + ' ' + className
  }, data, "\xA0", /*#__PURE__*/_react["default"].createElement("span", {
    className: "currency"
  }, currency));
};
var PositionHistoryComponent = function PositionHistoryComponent(_ref) {
  var data = _ref.data,
    instruments = _ref.instruments,
    fetching = _ref.fetching,
    config = _ref.config,
    notionalProductSymbol = _ref.notionalProductSymbol;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Pair'),
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return (0, _instrumentHelper.getInstrumentPropertyValueByInstrumentId)(instruments, row.original.PositionInstrumentId, 'Symbol');
      }
    }, {
      header: t('Type'),
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return makeCell(row.original.PositionType, baseClass('position'));
      }
    }, {
      header: t('Date/Time Opened'),
      className: 'date-cell',
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return (0, _MarginOpenPositionsComponent.renderCell)((0, _dateHelper.formatDate)(row.original.DateOpened), (0, _dateHelper.formatTime)(row.original.DateOpened));
      },
      meta: {
        textAlign: 'center'
      }
    }, {
      header: t('Date/Time Closed'),
      className: 'date-cell',
      cell: function cell(_ref5) {
        var row = _ref5.row;
        return (0, _MarginOpenPositionsComponent.renderCell)((0, _dateHelper.formatDate)(row.original.DateClosed), (0, _dateHelper.formatTime)(row.original.DateClosed));
      },
      meta: {
        textAlign: 'center'
      }
    }, {
      header: t('Total Repaid'),
      id: 'Total Repaid',
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return makeCell((0, _numberFormatter.formatNumberToLocale)(row.original.RepaidLiabilityNotional, notionalProductSymbol), baseClass('total-accrued'), notionalProductSymbol);
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Total Interest'),
      id: 'Int. Accrued',
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return makeCell((0, _numberFormatter.formatNumberToLocale)(row.original.RemainingInterest || row.original.Interest || 0, row.original.PositionType === 'Long' ? row.original.QuoteProductSymbol : row.original.BaseProductSymbol), baseClass('int-accrued'), row.original.PositionType === 'Long' ? row.original.QuoteProductSymbol : row.original.BaseProductSymbol);
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Realized P&L'),
      meta: {
        textAlign: 'right'
      },
      id: 'Real. P&L',
      cell: function cell(_ref8) {
        var row = _ref8.row;
        // BigNumber is used for cases when value is like -0.00001 gets formatted to -0.00
        var value = (0, _bignumber.BigNumber)(row.original.RealizedPnL).dp(row.original.quoteProduct.DecimalPlaces, _bignumber.BigNumber.ROUND_HALF_UP);
        var formattedNumber = (0, _numberFormatter.formatNumberToLocale)(value, row.original.QuoteProductSymbol);
        return makeCell(formattedNumber, value.lt(0) && '-negative', row.original.QuoteProductSymbol);
      }
    }, {
      header: t('Status'),
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref9) {
        var row = _ref9.row;
        return row.original.PositionState;
      }
    }, {
      header: t('Close Reason'),
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref0) {
        var row = _ref0.row;
        return row.original.ChangeReason;
      }
    }];
  }, [t, instruments, notionalProductSymbol]);
  return /*#__PURE__*/_react["default"].createElement(_Table.Table, {
    data: data,
    columns: columns,
    className: baseClass(),
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
    // componentName="ClosedPositionsComponent"
  });
};

// t('Closed Positions')
PositionHistoryComponent.title = 'Position History';
PositionHistoryComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  instruments: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = PositionHistoryComponent;